import { createAssetManagementClient } from '@/shared/api/client'
import { validateResponseIsOk } from '@/shared/api/validation'

const client = createAssetManagementClient()

export const acceptAsset = (assetCode: string) => validateResponseIsOk(
  client.sendPost(`Asset/AcceptAsset/assetCode=${assetCode}`)
)
